import { IIntro } from '@/interfaces/layout';
import clsx from 'clsx';
import { PropsWithChildren } from 'react';

interface IProps extends IIntro, PropsWithChildren {
  whiteBlockPlacementClass?: string;
  supportingTextClass?: string;
  postTitleClassName?: string;
}

export const InsightsIntro = ({ preTitle, postTitle, title, supportingTextClass, children }: IProps) => {
  return (
    <div className="relative z-50 flex flex-col gap-y-[32px] mobile:gap-y-[60px]">
      <div className="relative z-[5] max-w-[768px]">
        {preTitle && (
          <p
            data-testid="intro-pre-title"
            className="font-mono font-medium uppercase tracking-[1.92px] text-base mb-xs text-purple-8 leading-2xl"
          >
            {preTitle}
          </p>
        )}
        {title && (
          <h1
            data-testid="intro-title"
            className={clsx(
              'text-black-10 mb-[16px] mobile:mb-[24px] text-4xl mobile:text-5xl leading-[48px] mobile:leading-[67px]',
            )}
          >
            {title}
          </h1>
        )}
        {postTitle && (
          <p
            data-testid="intro-post-title"
            className={clsx('intro-post-title text-black-6 mobile:text-xl', {
              [`${supportingTextClass}`]: supportingTextClass,
            })}
          >
            {postTitle}
          </p>
        )}
      </div>

      {children}
    </div>
  );
};
